import { render } from "./ServicesPage.vue?vue&type=template&id=6a9b5230&scoped=true&ts=true"
import script from "./ServicesPage.vue?vue&type=script&lang=ts"
export * from "./ServicesPage.vue?vue&type=script&lang=ts"

import "./ServicesPage.vue?vue&type=style&index=0&id=6a9b5230&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a9b5230"]])

export default __exports__